import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, OnInit, Output, input, inject } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { NgControlBaseComponent } from 'projects/components/util/ng-control-base.component';
import { CallbackWrapperService } from 'projects/login/src/app/services/callback-wrapper.service';
import { noop } from 'rxjs';
import { FieldMultiValidatorComponent } from '../field-multi-validator/field-multi-validator.component';

@Component({
  selector: 'pay-checkbox',
  imports: [NgClass, FieldMultiValidatorComponent],
  templateUrl: './checkbox.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxComponent extends NgControlBaseComponent implements ControlValueAccessor, OnInit {
  override ngControl: NgControl | null;
  override readonly cdRef: ChangeDetectorRef;
  override readonly callbackService: CallbackWrapperService;

  readonly name = input<string>('');
  readonly label = input<string>('');
  readonly disabled = input<boolean>(false);
  readonly size = input(24);
  readonly forceCdEvent = input<EventEmitter<void>>();
  @Output() valueChanged = new EventEmitter<boolean>();
  value: boolean = false;

  onChange: (value: boolean) => void = noop;
  onTouch: () => void = noop;

  constructor() {
    const ngControl = inject(NgControl, { optional: true });
    const cdRef = inject(ChangeDetectorRef);
    const callbackService = inject(CallbackWrapperService);

    super(cdRef, callbackService, ngControl);
    this.ngControl = ngControl;
    this.cdRef = cdRef;
    this.callbackService = callbackService;

    if (ngControl) {
      ngControl.valueAccessor = this;
    }

    this.registerOnChange((v) => this.valueChanged.emit(v));
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.forceCdEvent()?.subscribe(() => {
      this.cdRef.markForCheck();
    });
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouch = fn;
  }

  writeValue(value: boolean): void {
    this.onChange(value);
    this.value = value;
    this.cdRef.markForCheck();
    this.setPending();
  }

  isSelected() {
    return this.value;
  }

  toggle() {
    if (this.disabled()) return;

    this.writeValue(!this.value);
    this.cdRef.markForCheck();
  }
}
